var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.48 449.94A15 15 0 0 1 278 441.5l-70.5-144.93-144.93-70.49a15 15 0 0 1 1-27.41L435.48 49.08A15 15 0 0 1 455 68.6L305.4 440.54a15 15 0 0 1-13.4 9.39Zm-185.38-236 119.18 58a15 15 0 0 1 6.93 6.93l58 119.18L414 90Z",
    fill: "#ffffff",
    className: "fill-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.72 300.35a15 15 0 0 1-10.6-25.61L430.47 52.39a15 15 0 1 1 21.21 21.22L229.33 296a15 15 0 0 1-10.61 4.35Z",
    fill: "#ffffff",
    className: "fill-000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSvg);
export default __webpack_public_path__ + "static/media/sendSVG.cd5c157fc8d33e9f1038023991aaffc8.svg";
export { ForwardRef as ReactComponent };